/**
 * Evaluates a simple JS expression safely by exposing only
 * the allowed variables: data, scope, and anything added inside mergedScope.
 *
 * @param {string|any} expr The expression to evaluate.
 * @param {object} scope The merged scope containing data + additional variables.
 */
export function evalExpression(expr, scope = {}) {
  if (expr === undefined || expr === null) return expr;

  // If the value is not a string expression, return as-is (number, object, boolean, etc.)
  if (typeof expr !== 'string') return expr;

  // If the expression is a direct reference like "tempUnit"
  if (/^[a-zA-Z0-9_]+$/.test(expr) && scope[expr] !== undefined) {
    return scope[expr];
  }

  // Binding shortcut resolution: e.g. "unitBind": "tempUnit"
  // If the key is under `data`
  if (/^[a-zA-Z0-9_]+$/.test(expr) && scope.data && scope.data[expr] !== undefined) {
    return scope.data[expr];
  }

  try {
    // Evaluate expression in a restricted sandbox
    // Expose only "data" and "scope"
    const func = new Function('data', 'scope', `"use strict"; return (${expr});`);
    return func(scope.data, scope);
  } catch (e) {
    console.warn('Expression eval error:', expr, e);
    return undefined;
  }
}
